import { useTheme } from '@mui/material/styles';
import classNames from 'classnames';
import { useColorButtonStyles } from './colorButton.styles';
import { getColorStyle } from './colorButton.utils';

const COLOR_ELEMENT_BORDER_COMPENSATION = '2px';

interface ColorElementProps {
  isImage?: boolean;
  hexcode?: string;
  imageUrl?: string;
  size?: number;
}

const ColorElement = ({ isImage, hexcode, imageUrl, size = 3 }: ColorElementProps) => {
  const theme = useTheme();
  const { classes } = useColorButtonStyles();
  const colorStyle = getColorStyle({ isImage, hexcode, imageUrl });

  return (
    <div
      className={classNames(classes.colorOrImage)}
      style={{
        ...colorStyle,
        width: `calc(${theme.spacing(size)} + ${COLOR_ELEMENT_BORDER_COMPENSATION})`,
        height: `calc(${theme.spacing(size)} + ${COLOR_ELEMENT_BORDER_COMPENSATION})`,
      }}
    />
  );
};

export default ColorElement;
